import ApiService from "@/services/api/api.service";
import {
  ExecuteTagAssignmentRequest,
  ExecuteTagAssignmentResponse,
} from "@/services/tagAssignment/tagAssignment.api.types";
import TagAssignmentEndpoints from "@/services/tagAssignment/tagAssignment.endpoint";

export class TagAssignmentService {
  static async executeTagAssignment(
    workspaceId: string,
    startDate: string,
    endDate: string,
  ): Promise<ExecuteTagAssignmentResponse> {
    const data: ExecuteTagAssignmentRequest = {
      workspaceId,
      startDate,
      endDate,
    };

    const response = await ApiService.fetchData<
      ExecuteTagAssignmentRequest,
      ExecuteTagAssignmentResponse
    >({
      url: TagAssignmentEndpoints.EXECUTE_TAG_ASSIGNMENT,
      data,
      method: "POST",
    });

    return response.data;
  }
}
